// validate video file
export function validateVideoFile(
  file: File,
  options: {
    maxSize?: number;
    allowedTypes?: string[];
  } = {}
): { isValid: boolean; error?: string } {
  const {
    maxSize = 100 * 1024 * 1024, // 100MB default
    allowedTypes = [
      "video/mp4",
      "video/quicktime",
      "video/webm",
      "video/x-msvideo",
    ],
  } = options;

  // check file type
  if (!allowedTypes.includes(file.type)) {
    return {
      isValid: false,
      error: `file type ${file.type} is not allowed. allowed types: ${allowedTypes.join(", ")}`,
    };
  }

  // check file size
  if (file.size > maxSize) {
    return {
      isValid: false,
      error: `file size ${Math.round(file.size / 1024 / 1024)}MB exceeds limit of ${Math.round(maxSize / 1024 / 1024)}MB`,
    };
  }

  return { isValid: true };
}
